import React from 'react';
import { IconCheckMark24pxSvg } from 'apps/sigma2-ui/src/components/svg/IconCheckMark24px';
import { IconDash24pxSvg } from 'apps/sigma2-ui/src/components/svg/IconDash24px';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';

export const SlateMetric = ({
  metric,
  tooltip,
  value,
}: {
  metric: boolean;
  tooltip: string;
  value: string;
}) => {
  return (
    <div className="flex flex-row gap-2 items-center">
      {(metric && (
        <div className="rounded-lg bg-[#A6ED8E4D]">
          <IconCheckMark24pxSvg
            svg={{
              className: 'w-4 h-4 text-green-600',
            }}
          />
        </div>
      )) || (
        <div className="rounded-lg bg-[#DBDBDB4D]">
          <IconDash24pxSvg
            svg={{
              className: 'w-4 h-4 text-gray-600',
            }}
          />
        </div>
      )}
      <Paragraph textColor="text-gray-600" className="text-xs text-gray-600">
        {tooltip}
      </Paragraph>

      <Paragraph textColor="text-black" className="text-sm text-black">
        {value}
      </Paragraph>
    </div>
  );
};
